import {
    MenuDto,
    PDiPModeltypebasicDto,
} from "../../services/Client";
import {Dispatch} from "react-redux";
// import {IState} from "../../reducer/Reducer";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import {GetMTBPDiPListParam} from "../../services/HATEOASClient";
import GeneralActions from "./GeneralActions";
import {ActionTypes} from "./ActionTypes";
import {IReduxState} from "../IReduxState";
import { AnyAction } from "redux";

const DerivateViewActions = {
    GetModeltypeColors(t: reactI18Next.TranslationFunction, menuDto: MenuDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const loadingScreenMessage = t('GLOBAL:LOAD_MODELTYPE_COLORS');
            const {client} = getState().general;
            if (!client.GET_modeltypeBasicColors(menuDto).canExecute()) {
                renderErrorToast({
                    message: "ERRORS:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:GET_MODELTYPE_COLORS",
                    timestamp: Date.now()
                }
                );
                return;
            }
            dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));
            client.GET_modeltypeBasicColors(menuDto).execute()
                .then((result) => {
                    dispatch(this.SetModeltypeColors(result));
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                }).catch((reason) => {
                    renderErrorToast({
                        message: "ERRORS:FAILED_LOAD_MODELTYPE_COLORS",
                        details: reason,
                        timestamp: Date.now()
                    }
                    );
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                });
        };
    },
    GetModeltypebasicPDiPList(t: reactI18Next.TranslationFunction, menuDto: MenuDto, mj4: number) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const loadingScreenMessage = t('GLOBAL:LOAD_MTB_PDIP_LIST');
            const {client} = getState().general;
            if (!client.GET_modeltypeBasicPDiPList(menuDto).canExecute()) {
                renderErrorToast({
                    message: "ERRORS:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:GET_MTB_PDIP_LIST",
                    timestamp: Date.now()
                }
                );
                return;
            }

            dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

            const reqParam: GetMTBPDiPListParam = {
                mj4: mj4
            };
            client.GET_modeltypeBasicPDiPList(menuDto).execute(reqParam)
                .then((result) => {
                    dispatch(this.SetModeltypebasicPDiPList(result));
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                }).catch((reason) => {
                    renderErrorToast({
                        message: "ERRORS:GET_MTB_PDIP_LIST",
                        details: reason,
                        timestamp: Date.now()
                    }
                    );
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                });
        };
    },
    SetModeltypeColors(colors: string[]) {
        return {type: ActionTypes.SET_MODELTYPE_COLORS, data: colors};
    },
    SetModeltypebasicPDiPList(dtos: PDiPModeltypebasicDto[]) {
        return {type: ActionTypes.SET_MODELTYPEBASIC_PDIP_LIST, data: dtos};
    },
    ReceiveModelTypeBasicExtraLinksAction(dto: MenuDto): AnyAction {
        return {type: ActionTypes.RECEIVE_MODEL_TYPE_BASIC_EXTRA_LINKS, modelTypeBasicExtraLinks: dto};
    },
};

export default DerivateViewActions;



// WEBPACK FOOTER //
// ./src/redux/actions/DerivateViewActions.tsx